import store  from '../store';
import db from '@/plugins/dexie';
import { TOKEN, USER_STORAGE } from '@/constants/STORAGE';
import { apiSetToken } from '@/services/api-varejoweb';

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}
export default async function conexao() {
  // Login do Usuário caso se conectou offline.
  const authToken = getSessionStorage(TOKEN, '');
  const useridnuvem = getSessionStorage(USER_STORAGE.useidnuvem, '');

  if (!useridnuvem) return;

  const payload = await db.usuario.where({ useidnuvem: String(useridnuvem) }).first() ||
                  await db.usuario.toCollection().first();

  if (!payload) return;

  let tokenValido = false;
  if (authToken && authToken !== '' && authToken !== 'null' && authToken !== 'undefined') {
    try {
      const parsedToken = typeof authToken === 'string' ? JSON.parse(authToken) : authToken;
      if (parsedToken && parsedToken.token) {
        apiSetToken(parsedToken.token);
        tokenValido = true;
      }
    } catch (e) {
      console.warn('Token em sessionStorage inválido:', e);
    }
  }

  if (!tokenValido && navigator.onLine) {
    try {
      const user = {
        codigo: payload.usecpf,
        senha: payload.usesenha,
      };
      await store.dispatch('auth/authenticate', user);
    } catch (err) {
      console.error('Erro ao reautenticar usuário online em conexao():', err);
    }
  }
}
